import { Model } from './model';
import { Checkout } from '.';
import { Type } from 'class-transformer';

export class FinixCheckout extends Model {
  @Type(() => Checkout)
  checkout: Checkout;
  transfer_id: string;
}
